import {GetAuthorizationsOdonto} from 'domain/usecases/private/authorizations-odonto/get-authorizations-odonto';
import {makeBFFApiUrl} from 'main/factories/http';

import {makeAuthorizeHttpClientDecorator} from 'main/factories/decorators';
import {RemoteGetAuthorizationsOdonto} from 'data/usecases';
import {authorizationsOdontoFlowEndpoints} from '../../endpoints';

export const makeGetAuthorizationsOdonto = (): GetAuthorizationsOdonto =>
	new RemoteGetAuthorizationsOdonto(
		makeBFFApiUrl(authorizationsOdontoFlowEndpoints.authorizationsOdontoHistory),
		makeAuthorizeHttpClientDecorator(),
	);
